import { SVGProps } from 'react';
const SvgArrowUpRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 16 8-8M10 8h6v6"
    />
  </svg>
);
export default SvgArrowUpRightSm;
